import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Button,
} from "reactstrap";
import "../../../styles/estilos.css";
import { withRouter } from "react-router-dom";
import { Select} from "react-inputs-validation";
import { connect } from "react-redux";
import Condiciones from  "./AcordeonCondiciones";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { datosListarCotizadores } from "../../../redux/reducers/rRamoLineaFinanciera";
import { guardCotizResp } from "../../../redux/actions/aCotizacionResponsabilidad";

class ListadoProductoResponsabilidad extends React.Component {
  constructor(props) {
    super(props);
    const { detalleCarrito } = this.props

       this.state = {
        selectDeducibles : detalleCarrito.selectDeducible ? detalleCarrito.selectDeducible: [],
        selectAmpPerdida : detalleCarrito.selectAmparos? detalleCarrito.selectAmparos[0].detalle: [],
        selectAmpInfielidad : detalleCarrito.selectAmparos ? detalleCarrito.selectAmparos[1].detalle : [],
        selectLimite : detalleCarrito.selectLimites ? detalleCarrito.selectLimites: [],
        arrayDatos: { 
            deducible: '', 
            ampInfidelidad: '', 
            ampPerdida: '',
            limite: '',
        },
        arrayValidadores: {
            hasDeducibleError: true,
            hasAmpInfidelidadError: detalleCarrito.carAreaCotizador==="empresa" ? true : false,
            hasAmpPerdidaError: detalleCarrito.carAreaCotizador==="empresa" ?  true : false,
            hasLimiteError: detalleCarrito.carAreaCotizador==="institucion" ?  true : false,
            }    
    }
    this.onActualizar = this.onActualizar.bind(this);

  }

  onActualizar(e) {
    const {arrayValidadores, arrayDatos,selectDeducibles,selectAmpPerdida,selectAmpInfielidad,selectLimite} = this.state;
    const {hasDeducibleError, hasAmpInfidelidadError, hasAmpPerdidaError,hasLimiteError} = arrayValidadores;
    const {ampInfidelidad, ampPerdida, deducible, limite} = arrayDatos;
    
    var varDeducible = '';
    var varAmpInfidelidad = '';
    var varAmpPerdida ='';
    var varLimite ='';
    if(selectDeducibles.length > 0) varDeducible = selectDeducibles.find(ded=> ded.id === deducible);
    if(selectAmpInfielidad.length > 0) varAmpInfidelidad = selectAmpInfielidad.find(inf=> inf.id === parseInt(ampInfidelidad , 10 ));
    if(selectAmpPerdida.length > 0) varAmpPerdida = selectAmpPerdida.find(per=> per.id === parseInt(ampPerdida , 10 ));
    if(selectLimite.length > 0) varLimite = selectLimite.find(lim=> lim.id === limite);
    //if(!hasDeducibleError && !hasAmpPerdidaError && !hasAmpInfidelidadError && !hasLimiteError){    
    if(!hasDeducibleError && !hasAmpPerdidaError && !hasLimiteError){
        this.props.metodoActualizarSelect({formEditado: true, botonContinuar:false, 
            arraySelects: {deducible:varDeducible, ampInfidelidad: varAmpInfidelidad, ampPerdida:varAmpPerdida, limite : varLimite}});
    }else{
        this.props.metodoActualizarSelect({formEditado: false, botonContinuar: true});
    }
  }

  // handle para regresar y editar la informacion de esta pagina
  async handleRegresar (params){
    // datos a preservar cuando regresamos al anterior paso
    const {detalleCarrito} = this.props;
    const datosCli = detalleCarrito.datosCliente;
    const activ = detalleCarrito.actividad;
    const lim = detalleCarrito.limite;
    const nivAcad = detalleCarrito.nivelAcademico;
    const tipInst = detalleCarrito.tipoInstitucion;
    const numEst = detalleCarrito.numeroEstudiantes;
    const fact = detalleCarrito.facturacion;
    const asesor = detalleCarrito.datosAsesor;
    const idCarrito = detalleCarrito.idCarrito;
    // Guardar los datos de este paso, en caso de que regresen
    // provincia y ciudad adaptar datos
    const provCli = {
        label: datosCli.provNombre,
        value: datosCli.provCodigoCore,
        paiCodigoCore: datosCli.paiCodigoCore,
    }
    const ciuCli = {
        label: datosCli.ciuNombre,
        value: datosCli.ciuCodigoCore,
    }
    // actividad adaptar datos
    const activCli = {
        label: activ ? activ.nomOpcion : '',
        value: activ ? activ.codOpcion : '',
    }
    // giro negocio adaptar datos
    const gn = datosCli.giroNegocio;
    const girNegCli = {
        label: gn.nombre,
        value: gn.id,
    }

    // Guardar estados
    const cotizProf = {
        // datos cliente
        rucCli: datosCli.cedula,
        nomEmpCli: datosCli.nombre,
        provCli: provCli,
        ciuCli: ciuCli,
        dirPriCli: datosCli.direccionPrincipal,
        cedCli: datosCli.cedulaSolicitante,
        nomCli: datosCli.nombreSolicitante,
        // datos empresa
        activEmp: activCli,
        limEmp: lim.codOpcion,
        factAnu: fact.codOpcion,
        giroNeg: girNegCli,
        // registrar estado anterior, si es que aplica
        sucur: this.props.ambosResp ?
             this.props.ambosResp.sucur : asesor.sucursalSeleccionada,
        // institucion
        nivAcad: nivAcad ? nivAcad.codOpcion : '',
        tipInst: tipInst ? tipInst.codOpcion : '',
        numEst: numEst ? numEst.codOpcion : '',
        // idCarrito
        idCarrito,
    }

    // guardar estado
    await this.props.guardarCotizResp(cotizProf);

    // llamar handle para regresar
    this.props.onClickAtras(params);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.arrayValidadores !== prevState.arrayValidadores)
        this.onActualizar();

        if (this.props.detalleCarrito !== prevProps.detalleCarrito)
        {

            this.onActualizaDatos();            
        }
}

onActualizaDatos() {    
    if(this.props.detalleCarrito.selectDeducible){
        var auxD = (this.props.detalleCarrito.selectDeducible.find(ded=> ded.selected === true));
    }
    if(this.props.detalleCarrito.selectAmparos){
        var auxAI = (this.props.detalleCarrito.selectAmparos[1].detalle.find(ded=> ded.selected === true));
        var auxAP = (this.props.detalleCarrito.selectAmparos[0].detalle.find(ded=> ded.selected === true));
    }    
    if(this.props.detalleCarrito.selectLimites){
        var auxL = (this.props.detalleCarrito.selectLimites.find(ded=> ded.selected === true));
    }
    let valorAmpInfidelidad=(this.props.detalleCarrito.selectAmparos && this.props.detalleCarrito.selectAmparos[1].detalle[0].id)?this.props.detalleCarrito.selectAmparos[1].detalle[0].id:""
    
    this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, 
        deducible: auxD? auxD.id : '', 
        ampInfidelidad: auxAI ? auxAI.id : valorAmpInfidelidad, 
        //ampInfidelidad:valorAmpInfidelidad,
        ampPerdida: auxAP ? auxAP.id : '',
        limite: auxL ? auxL.id : '',                      
      },
      arrayValidadores: { ...prevState.arrayValidadores, 
        hasDeducibleError: auxD ? false : true,
        hasAmpInfidelidadError: ((this.props.detalleCarrito.carAreaCotizador==="empresa") && (auxAI === undefined))? true : false,
        hasAmpPerdidaError:((this.props.detalleCarrito.carAreaCotizador==="empresa") && (auxAP === undefined)) ?  true : false,
        hasLimiteError: ((this.props.detalleCarrito.carAreaCotizador==="institucion") && (auxL === undefined)) ?  true : false,               
      },
    selectDeducibles : this.props.detalleCarrito.selectDeducible ? this.props.detalleCarrito.selectDeducible: [],
    selectAmpPerdida : this.props.detalleCarrito.selectAmparos? this.props.detalleCarrito.selectAmparos[0].detalle: [],
    selectAmpInfielidad : this.props.detalleCarrito.selectAmparos ? this.props.detalleCarrito.selectAmparos[1].detalle : [],
    selectLimite : this.props.detalleCarrito.selectLimites ? this.props.detalleCarrito.selectLimites: [],            
    })) 
}
componentDidMount() {
    this.onActualizaDatos();
    window.scroll(0, 0);
  }
  render() {
    const { detalleCarrito} = this.props;
    const { arrayDatos,selectDeducibles,selectAmpInfielidad,selectAmpPerdida,selectLimite} = this.state;
    const {ampInfidelidad, ampPerdida, deducible,limite} = arrayDatos;
   
    return (
        <Row>
            <Col>
                <Card className="flex-row ">
                    <CardBody>
                        <Col  lg={11} md={11} sm={11} xs={11} className="div-align-center">
                            <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-5"> {`Resumen`}</h4>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >RUC </Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.cedula}</Label></h5>                              
                                    </Col>
                                </Col>
                            </Row>                  
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Nombre de la empresa </Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.nombre}</Label></h5>                              
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Nombre del solicitante </Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.nombreSolicitante}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Provincia</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.provNombre}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Ciudad</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.ciuNombre}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>  
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Direción principal</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.datosCliente.direccionPrincipal}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>
                            {detalleCarrito.carAreaCotizador === "empresa"  &&
                            <div>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Actividad</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.actividad.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>    
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Límite por evento y agregado anual</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.limite.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>   
                            </div>
                            } 
                            {detalleCarrito.carAreaCotizador === "institucion"  &&
                            <div>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Nivel Académico</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.nivelAcademico.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>    
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Tipo de Institución</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.tipoInstitucion.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row> 
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label" >Número de Estudiantes</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.numeroEstudiantes.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>                              
                            </div>
                            } 

                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label">Facturación Anual</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control" >{detalleCarrito.facturacion.nomOpcion}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="bold-font-label">Giro de Negocio</Label></h5>
                                    </Col>
                                </Col>
                                <Col  lg={8} md={8} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5><Label className="input-type-label  form-control">{detalleCarrito.datosCliente.giroNegocio ?detalleCarrito.datosCliente.giroNegocio.nombre: ""}</Label></h5>
                                    </Col>
                                </Col>
                            </Row>                            
                             {/* <hr style={{borderTop: "1px solid"}}></hr> */}
                            <hr className="mb-5"></hr>    
                            {detalleCarrito.carAreaCotizador === "institucion"  &&
                            <div>
                                <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-3"> {`Coberturas Básicas`}</h4>
                                <h4 style={{fontSize:"larger" }} className="mb-3"> {`Responsabilidad Civil profesional`}</h4>  
                                <Row>
                                    <Col lg={4} md={4} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <h5 style={{fontSize:"larger", paddingTop:"10px" }}> {`Límite Asegurado USD`}</h5>
                                        </Col>
                                    </Col>
                                    <Col  lg={6} md={6} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Select
                                                //tabIndex="6" // Optional.[String or Number].Default: none.
                                                id={"limite"} // Optional.[String].Default: "". Input ID.
                                                name={"limite"} // Optional.[String].Default: "". Input name.
                                                value={limite} // Optional.[String].Default: "".
                                                optionList={selectLimite} // Required.[Array of Object(s)].Default: [].
                                                onChange={(limite, e) =>{this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, limite}, 
                                                    arrayValidadores: { ...prevState.arrayValidadores, hasLimiteError: limite ? false : true}}))
                                                }}
                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                                                validationCallback={res => this.setState({ hasLimiteError: res})}                          
                                                validationOption={{
                                                    name: "limite", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                    msgOnError: "Por favor seleccione un valor"
                                                }}
                                            /> 
                                        </Col>
                                    </Col>
                                </Row> 
                            </div>                                                               
                            }                               
                            <Row>
                                <Col lg={4} md={4} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <h5 style={{fontSize:"larger", paddingTop:"10px" }}> {`Deducible por evento USD`}</h5>
                                    </Col>
                                </Col>
                                <Col  lg={6} md={6} sm={12} xs={12}>
                                    <Col lg={12} md={12} sm={12} xs={12}>
                                        <Select
                                            //tabIndex="6" // Optional.[String or Number].Default: none.
                                            id={"deducible"} // Optional.[String].Default: "". Input ID.
                                            name={"deducible"} // Optional.[String].Default: "". Input name.
                                            value={deducible} // Optional.[String].Default: "".
                                            optionList={selectDeducibles} // Required.[Array of Object(s)].Default: [].
                                            onChange={(deducible, e) =>{this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, deducible}, 
                                                arrayValidadores: { ...prevState.arrayValidadores, hasDeducibleError: deducible ? false : true}}))
                                            }}
                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                            customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                                            validationCallback={res => this.setState({ hasDeducibleError: res})}                          
                                            validationOption={{
                                                name: "deducible", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                msgOnError: "Por favor seleccione un valor"
                                            }}
                                        /> 
                                    </Col>
                                </Col>
                            </Row> 
                            {/* <hr style={{borderTop: "1px solid"}}></hr> */}
                            <hr></hr>
                            {detalleCarrito.carAreaCotizador === "empresa"  &&
                            <div>                           
                                <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-3 mt-3"> {`Amparos Adicionales`}</h4>
                                <h4 style={{fontSize:"larger" }} className="mb-3"> {`Perdida de documento`}</h4>
                                <Row>
                                    <Col lg={4} md={4} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <h5 style={{ paddingTop:"10px" }}><Label>Sublímite  por evento y agregado</Label></h5>
                                        </Col>
                                    </Col>
                                    <Col  lg={6} md={6} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Select
                                                //tabIndex="6" // Optional.[String or Number].Default: none.
                                                id={"ampPerdida"} // Optional.[String].Default: "". Input ID.
                                                name={"ampPerdida"} // Optional.[String].Default: "". Input name.
                                                value={ampPerdida} // Optional.[String].Default: "".
                                                optionList={selectAmpPerdida} // Required.[Array of Object(s)].Default: [].
                                                onChange={(ampPerdida, e) =>{this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, ampPerdida}, 
                                                    arrayValidadores: { ...prevState.arrayValidadores, hasAmpPerdidaError: ampPerdida ? false : true}}))
                                                }}
                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                                validationCallback={res => this.setState({ hasAmpPerdidaError: res})}                          
                                                validationOption={{
                                                    name: "ampPerdida", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                    msgOnError: "Por favor seleccione un valor"
                                                }}
                                            />                              
                                        </Col>
                                    </Col>
                                </Row>     
                                <hr></hr>                                  
                                <h4 style={{fontSize:"larger" }} className="mb-3"> {`Infidelidad contra terceros (aplicable solo a personas juridicas)`}</h4>
                                <Row>
                                    <Col lg={4} md={4} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <h5 style={{ paddingTop:"10px" }}><Label>Sublímite  por evento y agregado</Label></h5>
                                        </Col>
                                    </Col>
                                    <Col  lg={6} md={6} sm={12} xs={12}>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                            <Select
                                                //tabIndex="6" // Optional.[String or Number].Default: none.
                                                id={"ampInfidelidad"} // Optional.[String].Default: "". Input ID.
                                                name={"ampInfidelidad"} // Optional.[String].Default: "". Input name.
                                                value={ampInfidelidad} // Optional.[String].Default: "".
                                                optionList={selectAmpInfielidad} // Required.[Array of Object(s)].Default: [].
                                                onChange={(ampInfidelidad, e) =>{this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, ampInfidelidad}, 
                                                    arrayValidadores: { ...prevState.arrayValidadores, hasAmpInfidelidadError: ampInfidelidad ? false : true}}))
                                                }}
                                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                                validationCallback={res => this.setState({ hasAmpInfidelidadError: res})}                          
                                                validationOption={{
                                                    name: "ampPerdida", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                    msgOnError: "Por favor seleccione un valor"
                                                }}
                                            />                              
                                        </Col>
                                    </Col>
                                </Row>
                                <hr></hr> 
                            </div> 
                            }
                            {detalleCarrito.carAreaCotizador === "institucion" &&  Object.keys(detalleCarrito.listaCoberturas).length > 0 &&
                                    <div>                               
                                        <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-5"> {`Coberturas Básicas`}</h4>
                                       <ul>  
                                       {detalleCarrito.listaCoberturas !== undefined
                                        && detalleCarrito.listaCoberturas.map((cobertura, i) =>
                                        <div>
                                            <Row >
                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                    <Col lg={12} md={12} sm={12} xs={12}>
                                                        <li  type="square" key={`amparo${i}`}><h4 style={{fontSize:"larger" }}><Label>{cobertura.descripcion}</Label></h4></li>
                                                    </Col>
                                                     {typeof(cobertura.detalle) === "object" &&
                                                        <div>
                                                        {cobertura.detalle !== undefined
                                                            && cobertura.detalle.map((detalle, i) =>
                                                            <Row className="mt-3">
                                                            <Col lg={4} md={4} sm={12} xs={12} className="div-align-center">
                                                                <h5 style={{paddingLeft:"30px" ,fontSize:"larger", fontWeight :"bold"  }}><Label>{detalle.descripcion}</Label></h5>
                                                            </Col>
                                                            <Col lg={8} md={8} sm={12} xs={12} className="div-align-center">
                                                                <h5 style={{paddingLeft:"30px" ,fontSize:"larger", color:"#af006e"}}><Label>{detalle.valor}</Label></h5>
                                                            </Col>                                                         
                                                            </Row>                                                      
                                                        )}
                                                        </div>
                                                    }                                                                                               
                                                </Col>
                                            </Row>
                                            <hr></hr>                          
                                        </div>
                                        )}
                                        </ul> 
                                        <hr></hr> 
                                    </div>
                            }   
                            { Object.keys(detalleCarrito.listaAmparos).length > 0 && 
                                <div>                               
                                    <h4 style={{ fontWeight: "bold", fontSize:"larger" }} className="mb-5"> {`Amparos Adicionales`}</h4>
                                   <ul>  
                                   {detalleCarrito.listaAmparos !== undefined
                                    && detalleCarrito.listaAmparos.map((amparo, i) =>
                                    <div>
                                        <Row >
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                    <li  type="square" key={`amparo${i}`}><h4 style={{fontSize:"larger" }}><Label>{amparo.descripcion}</Label></h4></li>
                                                </Col>
                                                {typeof(amparo.detalle) === "string" && amparo.detalle !=="" &&
                                                <Col lg={12} md={12} sm={12} xs={12}>
                                                    <h5 style={{ paddingLeft:"30px" }}><Label>{amparo.detalle}</Label></h5>
                                                </Col>
                                                }
                                                {detalleCarrito.carAreaCotizador === "institucion"  && typeof(amparo.detalle) === "object" && 
                                                    <div>
                                                    {amparo.detalle !== undefined
                                                        && amparo.detalle.map((detalle, i) =>
                                                        <Row className="mt-3">
                                                        <Col lg={4} md={4} sm={12} xs={12} className="div-align-center">
                                                            <h5 style={{paddingLeft:"30px" ,fontSize:"larger", fontWeight :"bold"  }}><Label>{detalle.descripcion}</Label></h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={12} xs={12} className="div-align-center">
                                                            <h5 style={{paddingLeft:"30px" ,fontSize:"larger", color:"#af006e"}}><Label>{detalle.valor}</Label></h5>
                                                        </Col>                                                         
                                                        </Row>                                                      
                                                    )}
                                                    </div>
                                                }                                                                                               
                                            </Col>
                                        </Row>   
                                        <hr></hr>                                  
                                    </div>
                                    )}
                                    </ul> 
                                </div>
                            }
                            <Row>
                                <Row className="mt-3"> 
                                    <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                                        <Button onClick={() => this.handleRegresar(detalleCarrito.carAreaCotizador)} className="btn btn-detail-gray">
                                            <FontAwesomeIcon icon={faChevronCircleLeft} style={{ marginRight: '0.1rem' }}/>{" REGRESAR"}
                                        </Button>
                                    </Col>
                                </Row> 
                            </Row>                   
                        </Col> 
                    </CardBody>
                </Card>
                { Object.keys(detalleCarrito.terminosCondiciones).length > 0  &&
                <div>
                    <Card className="flex-row ">
                        <CardBody>
                            <Row className="mt-3">
                                <Col md={2} sm={2} xs={2} style={{textAlign:"end"}}>
                                        <h5  style={{ fontWeight: "bold", fontSize:"larger" }}><Label>Nota:</Label></h5>
                                </Col>
                                <Col md={10} sm={10} xs={10}>
                                        <h5><Label className="input-type-label form-control" >El límite asegurado indicado en la Cobertura Básica "Responsabilidad Civil Profesional"
                                        constituye el límite máximo de responsabilidad por parte del asegurador. Todos los sublímitesindicados en la presente oferta forman parte de 
                                        dicho límite y no son en adición a éste</Label></h5>                              
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card className="flex-row ">
                        <CardBody>
                            <Row>
                                <Col md={12} sm={12} xs={12}>
                                    <Condiciones terminosCondiciones={detalleCarrito.terminosCondiciones}></Condiciones>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
                }
                <hr></hr> 
            </Col>
        </Row>
    );
  }
}

const mapStateToProps = state => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosEnviarPDFFinanciero: state.datosEnviarPDFFinanciero,
  ambosResp: state.rCotizacionResp.ambos,
});

const mapDispatchToProps = dispatch => {
  return {
    guardarCotizResp: data => dispatch(guardCotizResp(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ListadoProductoResponsabilidad)
);
